import React from "react";
import LayoutMain from "../../components/Layout/Main/Main";
import EnquireCheckBoxCollection from "../Enquires/CheckBoxCollection";
import EnquireCollection from "../Enquires/Collection";

const EnquiresCollectionData1 = [
  {
    title: "Name*",
    inputTitle: "inputName",
  },
  {
    title: "Email",
    inputTitle: "inputEmail",
  },
  {
    title: "Phone",
    inputTitle: "inputPhone",
  },
  {
    title: "Suburb*",
    inputTitle: "inputSubject",
  },
];

const EnquiresCollectionData2 = [
  {
    idName: "customRadio1",
    labelTitle: "On-Site Consultation",
  },
  {
    idName: "customRadio2",
    labelTitle: "Product Enquiry",
  },
  {
    idName: "customRadio3",
    labelTitle: "Wholesale Enquiry",
  },
  {
    idName: "customRadio4",
    labelTitle: "Other",
  },
];

const Contact = () => {
  return (
    <div>
      {" "}
      <LayoutMain>
        <section className="top-banner-contact">
          <div className="container-2">
            <div className="row">
              <div className="col  col-sm-12 col-md-12 col-lg-3 col-xl-3">
                <h4>Contact Us</h4>
              </div>
              <div className="col col-sm-12 col-md-12 col-lg-9 col-xl-9">
                <div className="row">
                  <div className="col col-sm-12 col-md-7 col-lg-7 col-xl-6 ">
                    <p>
                      111 Sutherland Street, Paddington <br />
                      NSW 2021
                      <br />
                      Sydney, Australia
                    </p>

                    <p>+612 9380 7957</p>
                    <p>
                      <a href="mailto:imagine@thinkoutsidegardens.com.au">
                        imagine@thinkoutsidegardens.com.au
                      </a>
                    </p>
                  </div>
                  <div className="col col-sm-12 col-md-5 col-lg-5 col-xl-6 ">
                    <p>
                      <small>Social Media</small>
                    </p>
                    <p>
                      <a
                        href="https://www.instagram.com/thinkoutsidegardens/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Instagram
                      </a>
                    </p>

                    <small>Newsletter Sign Up</small>
                    <br />
                    <form className="signup">
                      {" "}
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address*"
                      />
                      <button type="submit" className="btn btn-default">
                        Go
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="pt-140 pt-sm-50 mb-150">
          <div className="container-2">
            <div className="row contactform">
              <div className=" col-sm-12 col-md-12 col-lg-3 col-xl-3  ">
                <h4>Enquires</h4>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9 ">
                <p>
                  For wholesales, consultations and general enquires, fill out
                  this form and <br />
                  we will be in touch.
                </p>
                <form>
                  <EnquireCollection
                    data={EnquiresCollectionData1}
                    type="text"
                  />
                  <div className="form-group row">
                    <label
                      htmlFor="inputsubject"
                      className="col-sm-3 col-form-label"
                    >
                      I'm Interested In*
                    </label>
                    <div className="col-sm-9">
                      <EnquireCheckBoxCollection data={EnquiresCollectionData2} type='checkbox' />
                    </div>
                  </div>
                  <div className="form-group row">
                                <label htmlFor="inputmessage" className="col-sm-3 col-form-label">Comments</label>
                                <div className="col-sm-9">
                                    <textarea name="" cols="" rows="12" className="form-control" id="inputmessage"></textarea>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="inputmessage" className="col-sm-3 col-form-label">&nbsp;</label>
                                <div className="col-sm-9">
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="customCheck1"/>
                                        <label className="custom-control-label" htmlFor="customCheck1">Sign me up to our mailing list</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="inputmessage" className="col-sm-3 col-form-label">&nbsp;</label>
                                <div className="col-sm-9">
                                    <button type="submit" className="btn btn btn-grey-border btn-block text-uppercase" style={{maxWidth: "265px"}}>Submit Enquiry</button>
                                </div>
                            </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </LayoutMain>
    </div>
  );
};

export default Contact;
